import { render, staticRenderFns } from "./certificateDataDoctorQua.vue?vue&type=template&id=3766dea6&"
import script from "./certificateDataDoctorQua.vue?vue&type=script&lang=js&"
export * from "./certificateDataDoctorQua.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports